namespace GeniuzPOS.CustomReport {
    export namespace ReportCusSaleReportService {
        export const baseUrl = 'CustomReport/ReportCusSaleReport';

        export declare function Create(request: Serenity.SaveRequest<ReportCusSaleReportRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ReportCusSaleReportRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ReportCusSaleReportRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<ReportCusSaleReportRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "CustomReport/ReportCusSaleReport/Create",
            Update = "CustomReport/ReportCusSaleReport/Update",
            Delete = "CustomReport/ReportCusSaleReport/Delete",
            Retrieve = "CustomReport/ReportCusSaleReport/Retrieve",
            List = "CustomReport/ReportCusSaleReport/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>ReportCusSaleReportService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
